<template>
	<tr>
		<td>
			{{ map.blexonName }}<br />
			{{ map.blexonDescription }}
		</td>
		<td>
			<v-text-field
				v-model="map.fertigerName"
				@change="
					() => {
						map.fertigerName = map.fertigerName.trim();
						update();
					}
				"
			></v-text-field>
		</td>
		<td>
			<v-text-field
				v-model="map.fertigerText"
				@change="
					() => {
						map.fertigerText = map.fertigerText.trim();
						update();
					}
				"
			></v-text-field>
		</td>
	</tr>
</template>

<script>
import httpClient from "../store/httpClient";

export default {
	props: {
		map: {},
		fertiger: {},
	},
	methods: {
		async update() {
			try {
				this.$emit("loading", true);
				await httpClient().post(
					`api/Material/UpdateToolMap?fertigerId=${this.fertiger.id}`,
					this.map
				);
			} catch (err) {
				console.log(err);
			} finally {
				this.$emit("loading", false);
			}
		},
	},
};
</script>
